import { c as _c } from "react/compiler-runtime";
import { useId, useCallback } from 'react';
import { useMutation, useQueryClient, useQuery } from '@tanstack/react-query';
import type { PromptCode } from '@openclassrooms/js-ai-sdk';
import { clientApi } from '../../configuration';
import type { AIServerName, SDKPromptParameters, SDKPromptOptions, UsePromptReturn, AIResponse } from '../interfaces';
export type { UsePromptReturn, SDKPromptParameters };
export type UsePromptParams = {
  promptCode: PromptCode;
  serverName: AIServerName;
  shouldStream?: boolean;
};
export default function usePrompt(t0) {
  const $ = _c(23);
  const {
    promptCode,
    serverName,
    shouldStream: t1
  } = t0;
  const shouldStream = t1 === undefined ? false : t1;
  const hookId = useId();
  let t2;
  if ($[0] !== hookId) {
    t2 = ["prompt", hookId];
    $[0] = hookId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const queryKey = t2;
  const queryClient = useQueryClient();
  let t3;
  if ($[2] !== queryKey) {
    t3 = {
      queryKey,
      queryFn: _temp
    };
    $[2] = queryKey;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data
  } = useQuery(t3);
  let t4;
  if ($[4] !== promptCode || $[5] !== queryClient || $[6] !== queryKey || $[7] !== serverName || $[8] !== shouldStream) {
    t4 = async t5 => {
      const {
        input,
        parameters
      } = t5;
      const aiClient = clientApi.getAIClient(serverName);
      return new Promise((resolve, reject) => {
        const chunks = [];
        const onStreamData = shouldStream ? chunk => {
          chunks.push(chunk);
          queryClient.setQueryData(queryKey, chunks.join(""));
        } : undefined;
        aiClient.prompt(promptCode, {
          input,
          parameters,
          onStreamData
        }).then(response => {
          if (shouldStream) {
            resolve(chunks.join(""));
          } else {
            resolve(response);
          }
        }).catch(reject);
      });
    };
    $[4] = promptCode;
    $[5] = queryClient;
    $[6] = queryKey;
    $[7] = serverName;
    $[8] = shouldStream;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== queryClient || $[11] !== queryKey || $[12] !== t4) {
    t5 = {
      mutationKey: queryKey,
      mutationFn: t4,
      onSuccess(response_0) {
        queryClient.setQueryData(queryKey, response_0);
      }
    };
    $[10] = queryClient;
    $[11] = queryKey;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const {
    mutate,
    error,
    isPending
  } = useMutation(t5);
  let t6;
  if ($[14] !== mutate) {
    t6 = (input_0, parameters_0, t7) => {
      const options = t7 === undefined ? {} : t7;
      mutate({
        input: input_0,
        parameters: parameters_0
      }, options);
    };
    $[14] = mutate;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const prompt = t6;
  const t7 = data ?? "";
  let t8;
  if ($[16] !== isPending || $[17] !== prompt || $[18] !== t7) {
    t8 = {
      data: t7,
      isFetching: isPending,
      prompt
    };
    $[16] = isPending;
    $[17] = prompt;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const hookReturnValue = t8;
  let t9;
  if ($[20] !== error || $[21] !== hookReturnValue) {
    t9 = error === null ? {
      ...hookReturnValue,
      hasError: false,
      isLimitReached: false
    } : {
      ...hookReturnValue,
      hasError: true,
      errorStatusCode: error.status,
      isLimitReached: error.status === 429
    };
    $[20] = error;
    $[21] = hookReturnValue;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
}
async function _temp() {
  return "";
}